export class EventEmitter<EventMap extends Record<string, unknown>> {
  private readonly listeners = new Map<
    keyof EventMap,
    Set<(payload: EventMap[keyof EventMap]) => void>
  >();

  on<K extends keyof EventMap>(
    event: K,
    handler: (payload: EventMap[K]) => void,
  ): void {
    const handlers = this.listeners.get(event) ?? new Set();
    handlers.add(handler as (payload: EventMap[keyof EventMap]) => void);
    this.listeners.set(event, handlers);
  }

  off<K extends keyof EventMap>(
    event: K,
    handler: (payload: EventMap[K]) => void,
  ): void {
    this.listeners.get(event)?.delete(
      handler as (payload: EventMap[keyof EventMap]) => void,
    );
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
    this.listeners.get(event)?.forEach((handler) => {
      try {
        handler(payload);
      } catch (error) {
        console.error(`[SurfLiquid] Unhandled error in "${String(event)}" event handler:`, error);
      }
    });
  }
}
